import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT, getMaxPageWidth } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    display: flex;
    gap: ${rem(20)};
`;

export const Banner = styled.img`
    width: ${rem(320)};
    cursor: pointer;
    border-radius: ${rem(16)};
`;

export const MobileFiltersTitle = styled.span`
    display: block;
    text-align: center;
    font-size: ${({ theme }) => theme.fontSizes.h6};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
`;

export const MobileCloseButton = styled.div`
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: ${rem(25)};
    top: ${rem(10)};
    font-size: ${({ theme }) => theme.fontSizes.h6};
`;

export const MobileResetSection = styled.div`
    display: flex;
    justify-content: center;
`;

export const MobileFilters = styled.div`
    position: fixed;
    top: 0;
    height: 100vh;
    background: ${({ theme }) => theme.colors.white};
    left: 0;
    padding: ${rem(10)};
    z-index: 9999;
    margin-top: ${rem(80)};
    overflow-y: scroll;
    border-bottom: ${rem(80)} solid ${({ theme }) => theme.colors.white};

    @media (min-width: ${breakpoints.md}px) {
        display: none;
    }

    &.isOpen {
        transform: translateX(0);
        opacity: 1;
        transition: transform 0.5s, opacity 1s;
    }

    &.isClose {
        transform: translateX(-350px);
        opacity: 0;
        transition: transform 1s, opacity 1s;
    }
`;

export const DesktopFilters = styled.div`
    display: none;

    @media (min-width: ${breakpoints.md}px) {
        display: block;
        min-width: ${rem(320)};
    }
`;

export const BorderedPart = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${rem(16)};
    margin-bottom: ${rem(40)};
`;

export const Trainings = styled.div<{ withoutFilters?: boolean }>`
    width: 100%;
    padding: ${rem(10)} 0;

    @media (min-width: ${breakpoints.md}px) {
        padding: 0 0 0 ${(props) => (props.withoutFilters ? 0 : rem(25))};
    }
`;

export const MobileFilterButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: ${rem(10)} ${rem(4)};
    color: ${({ theme }) => theme.colors.primary};

    @media (min-width: ${breakpoints.md}px) {
        display: none;
    }
`;

export const Header = styled.div`
    padding-bottom: ${rem(10)};
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

export const Title = styled.h1<{ withMargin: boolean }>`
    font-size: ${({ theme }) => theme.fontSizes.h4};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    margin: ${(props) => (props.withMargin ? `${rem(MOBILE_HEADER_HEIGHT)} 0 ${rem(20)} 0` : `0 0 ${rem(20)} 0`)};

    @media (min-width: ${breakpoints.sm}px) {
        margin: ${(props) => (props.withMargin ? `${rem(DESKTOP_HEADER_HEIGHT)} 0 ${rem(40)} 0` : `0 0 ${rem(40)} 0`)};
    }
`;

export const SearchNoResults = styled.div<{ withoutMargin?: boolean }>`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    margin-top: ${(props) => (props.withoutMargin ? 0 : `${rem(20)}`)};
`;

export const Item = styled.div``;
